<template>
  <div class="background-color-white mb-5">
    <RouteBack class="pl-5 pt-3" />
    <v-row no-gutters>
      <v-col class="pb-3 px-5">
        <div>{{ product.name }}</div>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="!product.redeemable">
      <v-col class="line-height-1 pb-3 px-5">
        <div class="color-suva-grey font-size-xs">Starting at</div>
        <UnitPriceDisplay
          :byweight="product.byweight"
          :type="'modifier'"
          :unitPrice="product.cents"
        />
      </v-col>
    </v-row>
    <v-row
      no-gutters
      v-if="
        !product.redeemable ||
        total_points_remaining - product.redemption_points_offer > -1 ||
        club_free_products_qty_remaining(product.club_id) > 0
      "
    >
      <v-col class="px-5">
        <v-btn
          color="primary"
          height="38"
          width="144"
          rounded
          @click.stop="toProductDetail"
        >
          <div class="font-weight-semibold text-capitalize text-center">
            + add another
          </div>
        </v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters class="border-bottom">
      <v-col cols="12">
        <div class="font-weight-semibold py-5 text-center">
          Already in Cart:
        </div>
      </v-col>
    </v-row>
    <div class="no-overflow" style="max-height: 600px">
      <v-row class="d-flex justify-center" no-gutters>
        <v-col
          class="border-top-not-first-child"
          cols="12"
          v-for="cartItem in product.cartItems"
          :key="cartItem.item_id"
        >
          <CartItem
            :currentCartItem="true"
            :items="items"
            :modifiedQty="getQuantityFromModifiedCartItems(cartItem.item_id)"
            :modifyCartItems="modifyCartItems"
            :product="cartItem"
            :upc="product.upc"
          >
            <template v-slot:quantityButton="{ displayQuantity, less, more }">
              <QuantityButton
                :displayQuantity="displayQuantity"
                :exceededMax="exceededMax()"
                :less="less"
                :more="more"
              />
            </template>
          </CartItem>
        </v-col>
      </v-row>
    </div>
    <v-row class="background-color-seashell border-top" no-gutters>
      <v-col class="pt-5 px-5 text-center">
        <v-btn
          color="#e21b23"
          height="38"
          width="140"
          rounded
          @click.stop="removeAll"
        >
          <div
            class="color-white font-weight-semibold text-capitalize text-center"
          >
            remove all
          </div>
        </v-btn>
        <v-btn
          class="ml-5"
          color="success"
          height="38"
          width="140"
          rounded
          @click.stop="done"
        >
          <div class="font-weight-semibold text-capitalize text-center">
            done
          </div>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { updateObjectInArray, useSharedLibCart } from "@/util.js";
import { calculateCart } from "@/worker-api.js";
import CartItem from "@/components/Product/CartItem.vue";
import QuantityButton from "@/components/Product/QuantityButton.vue";
import RouteBack from "@/components/UI/RouteBack.vue";
import UnitPriceDisplay from "@/components/Product/UnitPriceDisplay.vue";

export default {
  name: "ProductAddFromCartView",
  components: {
    CartItem,
    QuantityButton,
    RouteBack,
    UnitPriceDisplay,
  },
  computed: {
    ...mapGetters("store", {
      total_points_remaining: "total_points_remaining",
      club_free_products_qty_remaining: "club_free_products_qty_remaining",
    }),
    ...mapState({
      cart: (state) => state.cart,
      sharedLibPromos: (state) => state.promotions.sharedLibPromos,
      storeInfo: (state) => state.store.info,
    }),
  },
  data() {
    return {
      items: null,
      modifiedCartItems: [],
    };
  },
  methods: {
    done() {
      if (this.modifiedCartItems.length) {
        this.$store.dispatch("cart/updateCartItems", this.modifiedCartItems);
      }
      this.$router.back();
    },
    exceededMax() {
      let qty = this.getCurrentQuantity();
      return this.product.redeemable
        ? this.product.is_redemption
          ? qty == this.getClubTotal()
          : this.total_points_remaining -
              (qty - this.product.cartQty + 1) *
                this.product.redemption_points_offer <
            0
        : false;
    },
    getClubTotal() {
      let clubTotal = this.storeInfo.coffee_clubs?.totals?.find(
        (t) => t.club_id === this.product.club_id,
      );
      return clubTotal?.free_products_qty;
    },
    getCurrentQuantity() {
      let products;
      if (this.modifiedCartItems.length) {
        var a = this.cart.products.map((i) => {
          let item = this.modifiedCartItems.find((m) => m.item_id == i.item_id);
          return item || i;
        });
        products = a;
      } else {
        products = this.cart.products;
      }
      let qty = products.reduce(
        (t, i) =>
          t +
          ((this.product.redemption_points_offer_id &&
            this.product.redemption_points_offer_id ===
              i.redemption_points_offer_id) ||
          (this.product.club_id && this.product.club_id === i.club_id)
            ? i.qty
            : 0),
        0,
      );
      return qty;
    },
    getQuantityFromModifiedCartItems(itemId) {
      if (!this.modifiedCartItems.length) return null;
      const mod = this.modifiedCartItems.find(
        (modifiedCartItem) => modifiedCartItem.item_id === itemId,
      );
      return mod ? mod.qty : null;
    },
    modifyCartItems(cartItem) {
      const has =
        this.modifiedCartItems.length &&
        this.modifiedCartItems.some((_) => _.item_id === cartItem.item_id);
      this.modifiedCartItems = has
        ? updateObjectInArray(this.modifiedCartItems, cartItem, "item_id")
        : [...this.modifiedCartItems, cartItem];
      // _setCartWithModifiedCartItemsForNewPricing(cartItem, this.cart.products);
      this.setPromotionsPricing();
    },
    async removeAll() {
      this.$store.dispatch("cart/removeAllCartItems", this.product);
      this.$store.commit("product/REMOVE_ALL_CART_ITEMS");
      this.$router.back();
    },
    async setPromotionsPricing() {
      const deliveryAmount = null; // not relevant to cart calculation until checkout
      const driverTip = null; // not relevant to cart calculation until checkout

      const sharedLibCart = useSharedLibCart(
        this.cart.products,
        this.sharedLibPromos,
        this.storeInfo.modifierGroups,
        deliveryAmount,
        this.cart.firstOrderDiscount,
        this.storeInfo.fee_buster_config,
        driverTip,
        this.storeInfo.points_config,
        this.storeInfo.price_increase,
      );
      const { items } = await calculateCart(sharedLibCart);
      this.items = items;
    },
    toProductDetail() {
      this.$store.dispatch("product/setCurrentProductDetails", this.product);
      if (this.$route.name === "product") {
        this.$router.push({
          name: "product",
          params: { upc: this.product.upc_encoded },
          query: { view: "modifiers" },
        });
      } else {
        this.$router.push({
          name: "product",
          params: {
            from: "addFromCart",
            upc: this.product.upc_encoded,
            view: "modifiers",
          },
        });
      }
    },
  },
  mounted() {
    this.setPromotionsPricing();
  },
  props: { product: Object },
};
</script>
